:host {
  --uui-button-tab-color: var(--uui-theme-core-400);
  --uui-button-tab-active-color: var(--uui-theme-on-core-700);
  --uui-button-tab-bg-color: transparent;
  --uui-button-tab-bg-active-color: var(--uui-theme-core-400);
  --uui-button-tab-bg-click-color: var(--uui-theme-core-900);
  --uui-button-tab-hover-text-decoration: underline;
  --uui-button-tab-hover-color: var(--uui-theme-core-700);
  --uui-button-tab-bg-hover-color: var(--uui-theme-on-core-800);
  --uui-button-tab-border-color: var(--uui-theme-core-800);
  --uui-button-tab-border: 1px solid var(--uui-theme-core-900);
  --uui-button-tab-border-hover: 1px solid var(--uui-theme-core-800);
  --uui-button-tab-border-active: 1px solid transparent;
  --uui-button-tab-border-left: 0;
  --uui-button-tab-min-width: 100px;
  --uui-button-horizontal-padding: 1.25em;
  --uui-button-vertical-padding: 0.75em;
}

:host {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size, 16px);
  line-height: 1.25em;
  color: var(--uui-button-tab-color);
  font-weight: var(--uui-font-weight-normal);
}

button {
  background: var(--uui-button-tab-bg-color);
  cursor: pointer;
  outline: inherit;
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  padding-right: var(--uui-button-horizontal-padding);
  font-weight: 400;
  padding-left: var(--uui-button-horizontal-padding);
  padding-top: var(--uui-button-vertical-padding);
  padding-bottom: var(--uui-button-vertical-padding);
  color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  min-width: var(--uui-button-tab-min-width);
  border: var(--uui-button-tab-border);
  border-left-width: var(--uui-button-tab-border-left);
  border-radius: var(--uui-button-tab-border-radius);
}

/* active as in clicked */
button:active {
  --uui-button-tab-bg-color: var(--uui-button-tab-bg-click-color);
}

/* active as in selected */
:host([active]:not([active="false"])) {
  --uui-button-tab-bg-color: var(--uui-button-tab-bg-active-color);
  --uui-button-tab-color: var(--uui-button-tab-active-color);
  --uui-button-tab-border: var(--uui-button-tab-border-active);
}

/* selected and hovered */
:host([active]:not([active="false"]):hover) {
  text-decoration: var(--uui-button-tab-hover-text-decoration);
}

/* unselected and hovered */
:host(:not([active]):hover),
:host([active="false"]:hover) {
  --uui-button-tab-bg-color: var(--uui-button-tab-bg-hover-color);
  --uui-button-tab-color: var(--uui-button-tab-hover-color);
  --uui-button-tab-border: var(--uui-button-tab-border-hover);
  text-decoration: var(--uui-button-tab-hover-text-decoration);
}

/* unselected and clicked */
:host(:not([active]):active),
:host([active="false"]:active) {
  --uui-button-tab-color: var(--uui-button-tab-active-color);
}
